import {MaxiDingConfig} from "../configuration/configurations";

export const getDailyCheckInItems = (dateStr, token) => {
    const endpointUrl = MaxiDingConfig.getMaxiDailyCheckInUrl + dateStr;
    return fetch(endpointUrl, {
        method: 'GET',
        headers: {'Authorization': 'Bearer ' + token},
    });
}

export const getAvailableCheckInItems = (token) => {
    return fetch(MaxiDingConfig.getMaxiAvailableCheckInItemUrl, {
        method: 'GET',
        headers: {'Authorization': 'Bearer ' + token},
    });
}

export const doDailyCheckIn = (dateStr, checkInItemIds, token) => {
    const requestBody = JSON.stringify({
        checkInDate: dateStr,
        checkInItemIds,
    });
    return fetch(MaxiDingConfig.dailyCheckInUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token},
        body: requestBody,
    });
}

export const confirmDailyCheckIn = (dateStr, isConfirmed, token) => {
    const requestBody = JSON.stringify({
        checkInDate: dateStr,
        isConfirmed,
    });
    return fetch(MaxiDingConfig.dailyCheckInUrl, {
        method: 'PUT',
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token},
        body: requestBody,
    });
}

export const validateCheckInDate = (dateStr, withInDays) => {
    // dateStr: yyyy-MM-dd
    const dateParts = dateStr.split("-");
    const checkInDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

    const diffInMs = checkInDate - new Date();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    let rtn = 0;
    if (diffInDays > 0) {
        rtn = 1;
    } else if (Math.abs(diffInDays) <= withInDays) {
        rtn = 0;
    } else {
        rtn = -1;
    }

    return rtn;
}